// Auth Action Types
export const SIGN_UP_REQUEST = 'SIGN_UP_REQUEST';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAIL = 'SIGN_UP_FAIL';

export const SIGN_IN_REQUEST = 'SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAIL = 'SIGN_IN_FAIL';

// Cities Action Types

export const GET_CITIES_REQUEST = 'GET_CITIES_REQUEST';
export const GET_CITIES_SUCCESS = 'GET_CITIES_SUCCESS';
export const GET_CITIES_FAIL = 'GET_CITIES_FAIL';

// Verify Phone Code Action Types

export const VERIFY_PHONE_REQUEST = 'VERIFY_PHONE_REQUEST';
export const VERIFY_PHONE_SUCCESS = 'VERIFY_PHONE_SUCCESS';
export const VERIFY_PHONE_FAIL = 'VERIFY_PHONE_FAIL';

// Resend Code Action Types

export const RESEND_PHONE_REQUEST = 'RESEND_PHONE_REQUEST';
export const RESEND_PHONE_SUCCESS = 'RESEND_PHONE_SUCCESS';
export const RESEND_PHONE_FAIL = 'RESEND_PHONE_FAIL';

// get current user Action Types

export const GET_CURRENT_USER_REQUEST = 'GET_CURRENT_USER_REQUEST';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_FAIL = 'GET_CURRENT_USER_FAIL';

// update current user Action Types

export const UPDATE_CURRENT_USER_REQUEST = 'UPDATE_CURRENT_USER_REQUEST';
export const UPDATE_CURRENT_USER_SUCCESS = 'UPDATE_CURRENT_USER_SUCCESS';
export const UPDATE_CURRENT_USER_FAIL = 'UPDATE_CURRENT_USER_FAIL';

// booking orders Action Types
export const GET_BOOKING_ORDERS_REQUEST = 'GET_BOOKING_ORDERS_REQUEST';
export const GET_BOOKING_ORDERS_SUCCESS = 'GET_BOOKING_ORDERS_SUCCESS';
export const GET_BOOKING_ORDERS_FAIL = 'GET_BOOKING_ORDERS_FAIL';

// filter orders Action Types
export const FILTER_BOOKING_ORDERS_REQUEST = 'FILTER_BOOKING_ORDERS_REQUEST';
export const FILTER_BOOKING_ORDERS_SUCCESS = 'FILTER_BOOKING_ORDERS_SUCCESS';
export const FILTER_BOOKING_ORDERS_FAIL = 'FILTER_BOOKING_ORDERS_FAIL';

// cancel booking Action Types
export const CANCEL_BOOKING_BY_TUTOR_REQUEST =
  'CANCEL_BOOKING_BY_TUTOR_REQUEST';
export const CANCEL_BOOKING_BY_TUTOR_SUCCESS =
  'CANCEL_BOOKING_BY_TUTOR_SUCCESS';
export const CANCEL_BOOKING_BY_TUTOR_FAIL = 'CANCEL_BOOKING_BY_TUTOR_FAIL';

// Accept booking Action Types
export const ACCEPT_BOOKING_REQUEST = 'ACCEPT_BOOKING_REQUEST';
export const ACCEPT_BOOKING_SUCCESS = 'ACCEPT_BOOKING_SUCCESS';
export const ACCEPT_BOOKING_FAIL = 'ACCEPT_BOOKING_FAIL';

// update booking Action Types
export const UPDATE_BOOKING_REQUEST = 'UPDATE_BOOKING_REQUEST';
export const UPDATE_BOOKING_SUCCESS = 'UPDATE_BOOKING_SUCCESS';
export const UPDATE_BOOKING_FAIL = 'UPDATE_BOOKING_FAIL';

// Accept Book tutor by student Action Types
export const BOOK_TUTOR_REQUEST = 'BOOK_TUTOR_REQUEST';
export const BOOK_TUTOR_SUCCESS = 'BOOK_TUTOR_SUCCESS';
export const BOOK_TUTOR_FAIL = 'BOOK_TUTOR_FAIL';

// Get tutor profile
export const GET_TUTOR_PROFILE_REQUEST = 'GET_TUTOR_PROFILE_REQUEST';
export const GET_TUTOR_PROFILE_SUCCESS = 'GET_TUTOR_PROFILE_SUCCESS';
export const GET_TUTOR_PROFILE_FAIL = 'GET_TUTOR_PROFILE_FAIL';

// Get tutor profile
export const PROFILE_UPDATE_REQUEST = 'PROFILE_UPDATE_REQUEST';
export const PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS';
export const PROFILE_UPDATE_FAIL = 'PROFILE_UPDATE_FAIL';

// Get stages
export const GET_STAGES_REQUEST = 'GET_STAGES_REQUEST';
export const GET_STAGES_SUCCESS = 'GET_STAGES_SUCCESS';
export const GET_STAGES_FAIL = 'GET_STAGES_FAIL';

// START Session
export const START_SESSION_REQUEST = 'START_SESSION_REQUEST';
export const START_SESSION_SUCCESS = 'START_SESSION_SUCCESS';
export const OPEN_SESSION_SUCCESS = 'OPEN_SESSION_SUCCESS';
export const START_SESSION_FAIL = 'START_SESSION_FAIL';

// CREATE stream
export const CREATE_STREAM_REQUEST = 'CREATE_STREAM_REQUEST';
export const CREATE_STREAM_SUCCESS = 'CREATE_STREAM_SUCCESS';
export const CREATE_STREAM_FAIL = 'CREATE_STREAM_FAIL';

// stream destroyed by tutor
export const STREAM_DESTROYED_BY_TUTOR_REQUEST =
  'STREAM_DESTROYED_BY_TUTOR_REQUEST';
export const STREAM_DESTROYED_BY_TUTOR_SUCCESS =
  'STREAM_DESTROYED_BY_TUTOR_SUCCESS';
export const STREAM_DESTROYED_BY_TUTOR_FAIL = 'STREAM_DESTROYED_BY_TUTOR_FAIL';

// stream destroyed by tutor
export const SEND_LOGIN_CODE_REQUEST = 'SEND_LOGIN_CODE_REQUEST';
export const SEND_LOGIN_CODE_SUCCESS = 'SEND_LOGIN_CODE_SUCCESS';
export const SEND_LOGIN_CODE_FAIL = 'SEND_LOGIN_CODE_FAIL';

// stream destroyed by Student
export const STREAM_DESTROYED_BY_STUDENT_REQUEST =
  'STREAM_DESTROYED_BY_STUDENT_REQUEST';
export const STREAM_DESTROYED_BY_STUDENT_SUCCESS =
  'STREAM_DESTROYED_BY_STUDENT_SUCCESS';
export const STREAM_DESTROYED_BY_STUDENT_FAIL =
  'STREAM_DESTROYED_BY_STUDENT_FAIL';

export const CANCEL_BOOKING_BY_STUDENT_REQUEST =
  'CANCEL_BOOKING_BY_STUDENT_REQUEST';
export const CANCEL_BOOKING_BY_STUDENT_SUCCESS =
  'CANCEL_BOOKING_BY_STUDENT_SUCCESS';
export const CANCEL_BOOKING_BY_STUDENT_FAIL = 'CANCEL_BOOKING_BY_STUDENT_FAIL';

export const GET_ORDER_DETAILS_REQUEST = 'GET_ORDER_DETAILS_REQUEST';
export const GET_ORDER_DETAILS_SUCCESS = 'GET_ORDER_DETAILS_SUCCESS';
export const GET_ORDER_DETAILS_FAIL = 'GET_ORDER_DETAILS_FAIL';

export const GET_PREDEFINED_CANCEL_BOOKING_REASONS_REQUEST =
  'GET_PREDEFINED_CANCEL_BOOKING_REASONS_REQUEST';
export const GET_PREDEFINED_CANCEL_BOOKING_REASONS_SUCCESS =
  'GET_PREDEFINED_CANCEL_BOOKING_REASONS_SUCCESS';
export const GET_PREDEFINED_CANCEL_BOOKING_REASONS_FAIL =
  'GET_PREDEFINED_CANCEL_BOOKING_REASONS_FAIL';

export const APPLY_DISCOUNT_CODE_REQUEST = 'APPLY_DISCOUNT_CODE_REQUEST';
export const APPLY_DISCOUNT_CODE_SUCCESS = 'APPLY_DISCOUNT_CODE_SUCCESS';
export const APPLY_DISCOUNT_CODE_FAIL = 'APPLY_DISCOUNT_CODE_FAIL';
export const RESET_SUBMIT_DISCOUNT_CODE = 'RESET_SUBMIT_DISCOUNT_CODE';

export const REQUEST_SUBJECT_REQUEST = 'REQUEST_SUBJECT_REQUEST';
export const REQUEST_SUBJECT_SUCCESS = 'REQUEST_SUBJECT_SUCCESS';
export const REQUEST_SUBJECT_FAIL = 'REQUEST_SUBJECT_FAIL';

export const END_ONLINE_SESSION_REQUEST = 'END_ONLINE_SESSION_REQUEST';
export const END_ONLINE_SESSION_SUCCESS = 'END_ONLINE_SESSION_SUCCESS';
export const END_ONLINE_SESSION_FAIL = 'END_ONLINE_SESSION_FAIL';

export const CHECK_JOINING_SESSION_STATUS_REQUEST =
  'CHECK_JOINING_SESSION_STATUS_REQUEST';
export const CHECK_JOINING_SESSION_STATUS_SUCCESS =
  'CHECK_JOINING_SESSION_STATUS_SUCCESS';
export const CHECK_JOINING_SESSION_STATUS_FAIL =
  'CHECK_JOINING_SESSION_STATUS_FAIL';

export const UPDATE_SESSION_DURATION_REQUEST =
  'UPDATE_SESSION_DURATION_REQUEST';
export const UPDATE_SESSION_DURATION_SUCCESS =
  'UPDATE_SESSION_DURATION_SUCCESS';
export const UPDATE_SESSION_DURATION_FAIL = 'UPDATE_SESSION_DURATION_FAIL';

export const COMPLETE_BOOKING_REQUEST = 'COMPLETE_BOOKING_REQUEST';
export const COMPLETE_BOOKING_SUCCESS = 'COMPLETE_BOOKING_SUCCESS';
export const COMPLETE_BOOKING_FAIL = 'COMPLETE_BOOKING_FAIL';

export const GET_SESSION_HOURS_REQUEST = 'GET_SESSION_HOURS_REQUEST';
export const GET_SESSION_HOURS_SUCCESS = 'GET_SESSION_HOURS_SUCCESS';
export const GET_SESSION_HOURS_FAIL = 'GET_SESSION_HOURS_FAIL';

export const RATE_SESSION_REQUEST = 'RATE_SESSION_REQUEST';
export const RATE_SESSION_SUCCESS = 'RATE_SESSION_SUCCESS';
export const RATE_SESSION_FAIL = 'RATE_SESSION_FAIL';

export const FETCH_MESSAGES_HISTORY_REQUEST = 'FETCH_MESSAGES_HISTORY_REQUEST';
export const FETCH_MESSAGES_HISTORY_SUCCESS = 'FETCH_MESSAGES_HISTORY_SUCCESS';
export const FETCH_MESSAGES_HISTORY_FAIL = 'FETCH_MESSAGES_HISTORY_FAIL';

export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAIL = 'SEND_MESSAGE_FAIL';

export const GET_INVITED_BOOKING_ORDERS_REQUEST =
  'GET_INVITED_BOOKING_ORDERS_REQUEST';
export const GET_INVITED_BOOKING_ORDERS_SUCCESS =
  'GET_INVITED_BOOKING_ORDERS_SUCCESS';
export const GET_INVITED_BOOKING_ORDERS_FAIL =
  'GET_INVITED_BOOKING_ORDERS_FAIL';

export const CHANGE_BOOKING_STATUS_REQUEST = 'CHANGE_BOOKING_STATUS_REQUEST';
export const CHANGE_BOOKING_STATUS_SUCCESS = 'CHANGE_BOOKING_STATUS_SUCCESS';
export const CHANGE_BOOKING_STATUS_FAIL = 'CHANGE_BOOKING_STATUS_FAIL';

export const GET_SUBJECTS_REQUEST = 'GET_SUBJECTS_REQUEST';
export const GET_SUBJECTS_SUCCESS = 'GET_SUBJECTS_SUCCESS';
export const GET_SUBJECTS_FAIL = 'GET_SUBJECTS_FAIL';

export const GET_SUB_SUBJECTS_REQUEST = 'GET_SUB_SUBJECTS_REQUEST';
export const GET_SUB_SUBJECTS_SUCCESS = 'GET_SUB_SUBJECTS_SUCCESS';
export const GET_SUB_SUBJECTS_FAIL = 'GET_SUB_SUBJECTS_FAIL';

export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SET_SUBJECTS = 'SET_SUBJECTS';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const OPEN_SNACK = 'OPEN_SNACK';
export const CLOSE_SNACK = 'CLOSE_SNACK';
export const RESET_PHONE = 'RESET_PHONE';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_INTERCOM_USER_ID = 'SET_INTERCOM_USER_ID';
export const RESET_TUTOR_PROFILE = 'RESET_TUTOR_PROFILE';
export const SET_SEARCH_WORD = 'SET_SEARCH_WORD';
export const RESET_CURRENT_REFINMENTS = 'RESET_CURRENT_REFINMENTS';
export const SET_NUMBER_OF_HITS = 'SET_NUMBER_OF_HITS';
export const RESET_INDICATORS = 'RESET_INDICATORS';
export const SET_VERIFY_PHONE_ERROR = 'SET_VERIFY_PHONE_ERROR';
export const SET_PREV_PATH = 'SET_PREV_PATH';
export const SET_STEPPER_DATA = 'SET_STEPPER_DATA';
export const SET_STAGE = 'SET_STAGE';
export const RESET_SEARCH_WORD = 'RESET_SEARCH_WORD';

// Booking Flow Actions
export const SET_BOOKING_FLOW_DATA = 'SET_BOOKING_FLOW_DATA';
export const SET_BOOKING_FLOW_CURRENT_TIME = 'SET_BOOKING_FLOW_CURRENT_TIME';

// Call Actions
export const SET_BOOKING = 'SET_BOOKING';
export const ADD_LOG = 'ADD_LOG';
export const UPDATE_STUDENTS_LIST = 'UPDATE_STUDENTS_LIST';
export const UPDATE_NETWORK_STATUS = 'UPDATE_NETWORK_STATUS';
export const UPDATE_CONNECTION_STATUS = 'UPDATE_CONNECTION_STATUS';
export const ACTIVATE_TIMER = 'ACTIVATE_TIMER';
export const DEACTIVATE_TIMER = 'DEACTIVATE_TIMER';
export const SET_TIMER_INTERVAL = 'SET_TIMER_INTERVAL';
export const CLEAR_TIMER_INTERVAL = 'CLEAR_TIMER_INTERVAL';
export const SET_SESSION_DETAILS = 'SET_SESSION_DETAILS';
export const SET_SESSION_DURATION = 'SET_SESSION_DURATION';

export const CHANGE_PHONE_NUMBER_VERIFY_PHONE_REQUEST =
  'CHANGE_PHONE_NUMBER_VERIFY_PHONE_REQUEST';
export const CHANGE_PHONE_NUMBER_VERIFY_PHONE_SUCCESS =
  'CHANGE_PHONE_NUMBER_VERIFY_PHONE_SUCCESS';
export const CHANGE_PHONE_NUMBER_VERIFY_PHONE_FAIL =
  'CHANGE_PHONE_NUMBER_VERIFY_PHONE_FAIL';

export const CHANGE_PHONE_NUMBER_RESEND_PHONE_REQUEST =
  'CHANGE_PHONE_NUMBER_RESEND_PHONE_REQUEST';
export const CHANGE_PHONE_NUMBER_RESEND_PHONE_SUCCESS =
  'CHANGE_PHONE_NUMBER_RESEND_PHONE_SUCCESS';
export const CHANGE_PHONE_NUMBER_RESEND_PHONE_FAIL =
  'CHANGE_PHONE_NUMBER_RESEND_PHONE_FAIL';

export const CHANGE_PHONE_NUMBER_SEND_VERIFICATION_CODE_REQUEST =
  'CHANGE_PHONE_NUMBER_SEND_VERIFICATION_CODE_REQUEST';
export const CHANGE_PHONE_NUMBER_SEND_VERIFICATION_CODE_SUCCESS =
  'CHANGE_PHONE_NUMBER_SEND_VERIFICATION_CODE_SUCCESS';
export const CHANGE_PHONE_NUMBER_SEND_VERIFICATION_CODE_FAIL =
  'CHANGE_PHONE_NUMBER_SEND_VERIFICATION_CODE_FAIL';

export const SEND_CHANGE_PHONE_NUMBER_VERIFICATION_CODE_REQUEST =
  'SEND_CHANGE_PHONE_NUMBER_VERIFICATION_CODE_REQUEST';
export const SEND_CHANGE_PHONE_NUMBER_VERIFICATION_CODE_SUCCESS =
  'SEND_CHANGE_PHONE_NUMBER_VERIFICATION_CODE_SUCCESS';
export const SEND_CHANGE_PHONE_NUMBER_VERIFICATION_CODE_FAIL =
  'SEND_CHANGE_PHONE_NUMBER_VERIFICATION_CODE_FAIL';
